import React from "react";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import Image from "next/image";
import StarIcon from "../../../public/images/star_gold.svg";
import {CkEditorPagesContentWrapper} from "@/styles/GlobalStyles";

const Wrap = styled.section`
  width: 100%;
  padding: 100px 0;
  

    @media only screen and (${breakpoints.mobile}) {
        padding:20px;
    }
    
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 0 auto;
  text-align: center;
`;

const ReviewLine = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #253b2f;
  opacity: 0.9;

    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;
        gap:0;
    }
`;

const Stars = styled.span`
  color: #f3b33d;
  letter-spacing: 2px;
  font-size: 16px;
    padding-top: 5px;
`;

const Title = styled.h2`
  margin: 6px 0 10px;
  line-height: 1.15;
  font-weight: 800;
  text-transform: uppercase;
  color: #c49959;
`;

const Subtitle = styled.p`
  margin: 0 auto 22px;
  max-width: 800px;
  font-size: 18px;
  line-height: 1.6;
  color: #222;
  opacity: 0.9;
    margin-bottom: 50px;

    @media only screen and (${breakpoints.mobile}) {
        margin-bottom: 20px;
    }
    
`;
const CTA = styled.a`
    margin: 12px 0 24px;
    background: #FF5A5F;
    color: #fff;
    border: 0;
    padding: 15px 32px;
    font-size: 20px;
    cursor: pointer;
    text-decoration: none;

    /* Button */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    width: fit-content;

    background: #FF5A5F;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    
    align-self: center;
    justify-self: center;

`;
export default function StaticPageReviewsSection({
                                                     reviewText,
                                                     title,
                                                     description,
                                                     link,
                                                     buttonText

}) {
  return (
    <Wrap>
      <Inner>
        <ReviewLine>
          <Stars>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
          </Stars>
            {reviewText && <span style={{ color:'#144733'}}>{reviewText}</span>}
        </ReviewLine>
          {title && <Title>{title}</Title>}
          {description &&
              <CkEditorPagesContentWrapper
                  dangerouslySetInnerHTML={{__html: description}}
                  style={{padding:0}}
              />
          }
          {
              buttonText && <div
                  style={{
                      display:'flex',
                      justifyContent:'center',
                      alignItems:'center',
                  }}
              >
                  <CTA href={link ?? '#'}>{buttonText}</CTA>
              </div>
          }
      </Inner>
    </Wrap>
  );
}
